export enum InvoiceStatus {
  Open = "OPEN",
  Paid = "PAID"
}
